import { ITraitDots } from '../core/culture-index.model'

export interface ICultureIndexJobPost {
  id: string //  Job Post Id
  positionId: number // Culture index id
  positionHash: string
  customerKey: string
  companyCode: string // Culture Index Company Code

  cJobs: ICJob[]
}

export interface ICJob {
  id: number // positionAnswerId
  isIdeal: boolean
  isTypified: boolean
  traitPattern: string // Influencer, Operator etc...
  traitDots: ITraitDots
}

export enum CJobCategory {
  Research = 'Research',
  Visionary = 'Visionary',
  Organizational = 'Organizational',
  Social = 'Social',
  Other = 'Other',
}

export enum CJobPattern {
  // Research
  Scholar = 'Scholar',
  Specialist = 'Specialist',
  TechnicalExpert = 'Technical Expert',
  Craftsman = 'Craftsman',

  // Visionary
  Enterpriser = 'Enterpriser',
  Trailblazer = 'Trailblazer',
  Daredevil = 'Daredevil',
  Architect = 'Architect',
  Philosopher = 'Philosopher',

  // Organizational
  Operator = 'Operator',
  Facilitator = 'Facilitator',
  Administrator = 'Administrator',
  Coordinator = 'Coordinator',
  Traditionalist = 'Traditionalist',

  // Social
  Debater = 'Debater',
  Socializer = 'Socializer',
  Rainmaker = 'Rainmaker',
  Persuader = 'Persuader',
  Influencer = 'Influencer',

  // Other
  Avoidant = 'Avoidant',
  Chameleon = 'Chameleon',
}

export enum CultureIndexColor {
  BLUE = '#0040B8',
  RED = '#B8002B',
  GREEN = '#009440',
  YELLOW = '#FFCC00',
  GRAY = '#6F7376',
}

export type CJobPatternCategory = {
  [C in CJobCategory]: CJobPattern[]
}

export interface CJobCategoryToPattern {
  category: CJobCategory
  patterns: CJobPattern[]
  color: CultureIndexColor
}

export interface CJobPatternToCategory {
  pattern: CJobPattern
  category: CJobCategory
  color: CultureIndexColor
}

export const C_JOB_CATEGORY_PATTERNS: CJobCategoryToPattern[] = [
  {
    category: CJobCategory.Research,
    patterns: [CJobPattern.Scholar, CJobPattern.Specialist, CJobPattern.TechnicalExpert, CJobPattern.Craftsman],
    color: CultureIndexColor.BLUE,
  },
  {
    category: CJobCategory.Visionary,
    patterns: [CJobPattern.Enterpriser, CJobPattern.Trailblazer, CJobPattern.Daredevil, CJobPattern.Architect, CJobPattern.Philosopher],
    color: CultureIndexColor.RED,
  },
  {
    category: CJobCategory.Organizational,
    patterns: [CJobPattern.Operator, CJobPattern.Facilitator, CJobPattern.Administrator, CJobPattern.Coordinator, CJobPattern.Traditionalist],
    color: CultureIndexColor.GREEN,
  },
  {
    category: CJobCategory.Social,
    patterns: [CJobPattern.Debater, CJobPattern.Socializer, CJobPattern.Rainmaker, CJobPattern.Persuader, CJobPattern.Influencer],
    color: CultureIndexColor.YELLOW,
  },
  {
    category: CJobCategory.Other,
    patterns: [CJobPattern.Avoidant, CJobPattern.Chameleon],
    color: CultureIndexColor.GRAY,
  },
]

export const C_JOB_PATTERN_CATEGORIES: CJobPatternToCategory[] = C_JOB_CATEGORY_PATTERNS.reduce((acc, { category, patterns, color }) => {
  patterns.forEach(pattern => {
    acc.push({ pattern, category, color })
  })
  return acc
}, [] as CJobPatternToCategory[])

export enum QuestionnaireInviteStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
}
export interface IQuestionnaireInvite {
  appUserId: string
  status: QuestionnaireInviteStatus
  date: Date
}
export interface ICultureIndexCJobQuestion {
  questionNumber: number
  question: string
  languageId: number
  language: {
    languageId: number
    language: string
  }
  questionAnswers: ICultureIndexCJobQuestionAnswer[]
}

export interface ICultureIndexCJobQuestionAnswer {
  sortOrder: number
  displayText: string
}
